const PAGE = 0;
const ROWS = 200;

/**
 * The Roles screen neither filters nor paginates: it is a role selector plus a single composition
 * card. `queryParams` therefore always requests one fixed, wide page rather than exposing paging as
 * something a caller could vary.
 */
class FetchRoles {
	constructor(public readonly accountId: number) {
		Object.freeze(this);
	}

	get queryParams(): URLSearchParams {
		const params = new URLSearchParams();
		params.set('page', String(PAGE));
		params.set('rows', String(ROWS));
		return params;
	}
}

export default FetchRoles;
